import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Typography } from '@mui/material';
import { yupResolver } from '@hookform/resolvers/yup';
import Dialog from '../../../components/dialog/dialog';
import { ExportCsvModalStyled } from './export-csv-modal.style';
import { Button } from '../../../components/button/button';
import AutoCompleteFormField from '../../../components/form-fields/auto-complte-new/auto-complete-form-field';
import SelectFormField from '../../../components/form-fields/select-field/select-form-field';
import DateTimePickerFormField from '../../../components/form-fields/date-range-picker/date-range-picker-form-field';
import { formatStartDateEndDate } from '../../../utils/utils';
import { exportCsvModalValidations } from '../../../constants/validations';
import { fetchProjects } from '../../../services/projectsServices';

const ExportCsvModal = ({ onClose, onExport }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [projectOptions, setProjectOptions] = useState([]);

  const { control, watch, formState } = useForm({
    mode: 'all',
    resolver: yupResolver(exportCsvModalValidations()),
  });
  const { isValid } = formState;

  const dateFormat = 'YYYY-MM-DD';

  useEffect(() => {
    const loadProjects = async () => {
      try {
        const projects = await fetchProjects();
        setProjectOptions(
          projects
            .map((project) => ({
              label: `${project.id} | ${project.projectName}`,
              value: project.id,
            }))
            .sort((a, b) => a.label.localeCompare(b.label)),
        );
      } catch (error) {
        console.error('Error fetching projects:', error);
        setProjectOptions([]);
      }
    };

    loadProjects();
  }, []);

  const handleExport = async (type) => {
    const formatted = formatStartDateEndDate(watch()?.range, dateFormat);
    const startDate = formatted?.[0];
    const endDate = formatted?.[1];
    const project = watch()?.project;

    if (type === 'overtime' || type === 'timesheet' || type === 'cost') {
      setIsLoading(true);
      await onExport(type, startDate, endDate, project);
      setIsLoading(false);
    }
  };

  const exportType = watch()?.type;
  const isOvertime = exportType === 'overtime';

  return (
    <Dialog noScroll noFooter>
      <ExportCsvModalStyled>
        <div className="content">
          <div className="header">
            <Typography variant="h4">Timesheet CSV Export</Typography>
          </div>
          <div className="fields">
            <SelectFormField
              name="type"
              control={control}
              isRequired
              label={'Export Type'}
              placeholder="Select"
              options={[
                {
                  label: 'Hours Worked By User By Day Report',
                  value: 'overtime',
                },
                {
                  label: 'Time Tracked By User By Project Report',
                  value: 'timesheet',
                },
                {
                  label: 'Project Cost',
                  value: 'cost',
                },
              ]}
            />
            <AutoCompleteFormField
              name="project"
              control={control}
              disabled={isOvertime || !exportType}
              label="Project"
              placeholder="Select Project"
              options={projectOptions}
            />
            <DateTimePickerFormField label="Date Range" name="range" control={control} />
          </div>
          <div className="btn-wrap">
            <Button variant="outlined" className="cancel-btn" onClick={onClose}>
              Cancel
            </Button>
            <Button
              onClick={() => handleExport(watch()?.type)}
              disabled={!isValid || isLoading}
              isLoading={isLoading}
            >
              Save
            </Button>
          </div>
        </div>
      </ExportCsvModalStyled>
    </Dialog>
  );
};

export default ExportCsvModal;
